import React from "react";
import FormikControlContext from "../../../Contexts/FormikControlContext";
import useArrayGroupComponent from "../ArrayGroupComponent/useArrayGroupComponent";
import FormikControl from "../FormikControl/FormikControl";

const ObjectGroupComponent = ({ inputObject, productName }) => {
  const { shouldRenderField } = useArrayGroupComponent();
  return (
    <div>
      <h4 className="mb-3">{inputObject?.label}</h4>
      {inputObject?.obj?.map((field, index) => {
        const objName = inputObject.name;
        const shouldRender = shouldRenderField(field, objName);
        const { name, ...rest } = field;

        return shouldRender ? (
          <div className="mb-3" key={index}>
            <FormikControlContext.Provider
              value={{
                name: `${objName}.${name}`,
                arrObjName: objName,
                productName: productName || inputObject.productName,
                ...rest,
              }}
            >
              <FormikControl />
            </FormikControlContext.Provider>
          </div>
        ) : null;
      })}
      <hr />
    </div>
  );
};

export default ObjectGroupComponent;
